export default __webpack_public_path__ + "static/media/white_plus-small_icon.2042acd4.svg";